/* 闭环报送接口 */

import { GET, POST, download, uploading, GETNEW, POSTNEW, EXPORTNEW, POSTFormDataNEW, uploadingImg } from '@/request/http'

// 导出接口
export const exportClosedLoopData = p => EXPORTNEW('/studentgrowthfiles/safety-apply/export', p)

// 获取闭环报送的table数据
export const getClosedLoopData = p => POST('/studentgrowthfiles/plan/apply/page/{planType}', p)

// 下载模板
// export const downTemplate = p => EXPORTNEW('', p)

// 导入
// export const toLeadClosedLoopData = p => POSTFormDataNEW('', p)

// 登记闭环报送数据
export const registerClData = p => POST('/studentgrowthfiles/safety-apply/save', p)

// 获取闭环报送的类型
export const getClTypeData = p => POST('/studentgrowthfiles/commonType/createrRule', p)

// 登记时获取事件类型
export const getClEventTypeData = p => GET('/studentgrowthfiles/plan/options/findListBycode', p)

// 提交闭环报送的登记数据
export const saveClosedLoopData = p => POSTNEW('/studentgrowthfiles/safety-apply/save', p)

// 根据申请id获取数据详情
export const idGetDetailData = p => GET('/studentgrowthfiles/safety-apply/get', p)

// 获取闭环统计数据
export const getClStatisticsChartsData = p => POSTNEW('/studentgrowthfiles/safety-apply/statisticshkj', p)

// 根据申请id删除数据
export const delRepealApplyData = p => GETNEW('/studentgrowthfiles/plan/apply/repeal-apply', p)

// 事件处理结果反馈记载
export const submitClEventRecord = p => POSTNEW('/studentgrowthfiles/safety-apply/addEventRecord', p)

// 安全信息员页面分页
export const getSecurityInfoOfficerData = p => POSTNEW('/studentgrowthfiles/safetyInfomation/page', p)



// WEBPACK FOOTER //
// ./src/api/modules/closedLoopSubmitted.js